(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ChekinPro", [], factory);
	else if(typeof exports === 'object')
		exports["ChekinPro"] = factory();
	else
		root["ChekinPro"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 